import axios from "axios";
const host = "https://cdcbm.cdcee.com"; // $domain
const api = host + "/strait/asset/";

export function $get(url, params) {
  let config = {
    params: params
  };
  return axios.get(api + url, config);
}



// WEBPACK FOOTER //
// ./src/utils/http.js